import type { BlockFaqs } from 'types/block-faqs';
import React from 'react';
import { RichText, Wrap, Collapsible, Button } from '@leafwell/components';
import FaqsJson from './structured-data/faqs';
import HeadingBody from './heading-body';
import WysiwygContent from './wysiwyg-content';
import { useEventsTracker } from 'contexts/eventsTracker';

const Faqs: React.FC<BlockFaqs & { pageType?: string }> = ({
  sectionId,
  instanceId,
  title,
  description,
  items,
  button,
  pageType,
}) => {
  const { trackEvent } = useEventsTracker();

  return (
    <section id={sectionId} itemID={`FAQ-${instanceId}`}>
      <Wrap
        className={[
          'grid',
          pageType !== 'post'
            ? 'lg:grid-cols-2 gap-x-24 lg:items-center'
            : '!px-0',
        ].join(' ')}
      >
        <div className="grid gap-y-3">
          <div className="grid gap-y-6">
            <HeadingBody
              level="2"
              tagName="h2"
              title={title}
              className="font-semibold"
            />
            {description?.length > 0 && (
              <WysiwygContent
                content={description}
                className="!text-gray-700"
              />
            )}
          </div>
          {button && (
            <Button
              label={button.title}
              href={button.url}
              rounded={true}
              variant="secondary"
              className="w-full md:w-fit h-fit"
              onClick={() => {
                trackEvent({
                  event: 'select_content',
                  content_type: button.title,
                  item_id: `FAQ-${instanceId}`,
                  action: 'FAQ-click-cta',
                });
              }}
            />
          )}
        </div>
        <div className="grid gap-y-3">
          {items.map(({ id, title, content }) => (
            <Collapsible
              key={id}
              title={title}
              variant="border"
              titleBold={true}
              titleClass="text-base"
            >
              <RichText content={content} />
            </Collapsible>
          ))}
        </div>
        <FaqsJson items={items} />
      </Wrap>
    </section>
  );
};

export default Faqs;
